export default __webpack_public_path__ + "static/media/BE01.0dc446d3.mp3";